import cn from 'classnames';

import Heading from 'components/common/Heading';
import Subheading from 'components/common/Subheading';
import useQuery from 'hooks/useQuery';
import MariaSharapovaLogo from 'images/logo/mariaSharapovaLogo.svg';
import MyHealthyDishLogo from 'images/logo/myHealthyDishLogo.png';
import TempoByKrogerLogo from 'images/logo/tempoByKroger.png';
import TempoLogoWhite from 'images/logo/tempoLogoWhite.svg';
import TempoLogoYellow from 'images/logo/tempoYellowLogo.svg';

const HeaderLogo = ({ isSharapova, isMyHealthyDish }) => {
  const { isQueryParamTrue: hasKrogerParam } = useQuery('kroger', 'true');
  const tempoLogo = hasKrogerParam ? TempoByKrogerLogo : TempoLogoWhite;

  if (isSharapova) {
    return (
      <div className="mb-3 flex flex-row items-center justify-center bp1:mb-4">
        <img className="w-16 bp1:w-32" src={TempoLogoYellow} alt="Tempo Logo" />
        <div className="mx-3 h-5 w-[1px] bg-[#D3E742] bp1:mx-6 bp1:h-10" />
        <img className="w-24 bp1:w-44" src={MariaSharapovaLogo} alt="Maria Sharapova Logo" />
      </div>
    );
  }
  if (isMyHealthyDish) {
    return (
      <img
        className="mt-8 w-56 bp1:w-80 bp2:mt-0"
        src={MyHealthyDishLogo}
        alt="My Healthy Dish Logo"
      />
    );
  }

  return <img className="w-28 pb-2 bp2:w-36" src={tempoLogo} alt="Logo" />;
};

HeaderLogo.propTypes = {
  isSharapova: PropTypes.bool,
  isMyHealthyDish: PropTypes.bool,
};

const AdSourceHeaderContent = ({ isSharapova, isMyHealthyDish }) => {
  return (
    <div
      className={cn(
        'px-6 py-8 text-center',
        isSharapova || isMyHealthyDish ? ' bg-tempo-navy-100' : 'bg-tempo-blue-120'
      )}
    >
      <div className="mx-auto max-w-xl">
        <HeaderLogo isSharapova={isSharapova} isMyHealthyDish={isMyHealthyDish} />
        <Heading className="h4 bp1:h2 text-white-100">Fresh, never frozen meal delivery</Heading>
        <Subheading className="text-white-100" brandStylesOverrides="text">
          Prepared, protein-packed meals that cook in 2 minutes.
        </Subheading>
      </div>
    </div>
  );
};

AdSourceHeaderContent.propTypes = {
  isSharapova: PropTypes.bool,
  isMyHealthyDish: PropTypes.bool,
};

export default AdSourceHeaderContent;
